import { render, staticRenderFns } from "./platePay.vue?vue&type=template&id=552fb9ec&"
import script from "./platePay.vue?vue&type=script&lang=js&"
export * from "./platePay.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports